import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(),
        getByLicense: state => licenseId => {
            return state.objs.filter(o => o.license === licenseId);
        },
        getByCustomer: state => userId => {
            return state.objs.filter(o => o.customer === userId);
        },
        getByTable: state => tableId => {
            return state.objs.filter(o => o.tableRef === tableId);
        }
    },
    mutations: {
        ...functions.createDefaultMutations()
    },
    actions: {
        ...functions.createDefaultActionsWithStore()
    },
}